import { ISeoMetaData } from 'data/seo'

export const seoObjectLookup = (seoMetaData: ISeoMetaData[], currentPathName: string) : ISeoMetaData | undefined => {
  return seoMetaData.find(x => {
    if (x.path instanceof RegExp) {
      // ignore case
      const ciRegExp = new RegExp(x.path, 'i')
      return Boolean(currentPathName.match(ciRegExp))
    } else {
      // Compare both as lowercase
      const lookupPath = x.path.toLowerCase().replace(/\/$/, '')
      return lookupPath === currentPathName.toLowerCase()
    }
  })
}
